import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, Grid, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import TextEditBlock from '../invoice/texteditblock';

export default function DeleteFromHistoryConfirmationDialog(props) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [reason, setReason] = useState('');
    const { t } = useTranslation();

    const onConfirm = () => {
        props.confirm(reason);
    };

    const onCancel = () => {
        props.cancel();
    };

    const onChange = (event) => {
        setReason(event.target.value);
    };

    return (
        <Dialog
            onClose={onCancel}
            aria-labelledby="simple-dialog-title"
            open={props.open}
            fullWidth={true}
            maxWidth={'md'}
            fullScreen={fullScreen}>
            <DialogContent dividers>
                <Grid container>
                    <Grid item xs={12}>
                        <h3>{t('order.confirmRemoveOrder')}</h3>
                        {t('order.removeOrderReasonHint')}
                    </Grid>
                    <Grid item xs={12}>
                        <TextEditBlock
                            xs={12}
                            md={12}
                            name={'remove-reason'}
                            label={t('order.removeOrderReason')}
                            value={reason}
                            onChange={onChange}
                            maxLength={250}
                            required={true}
                            showCounter={true}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    disabled={!reason || reason.length < 3}
                    variant="contained"
                    color="primary"
                    name="btn-confirm"
                    onClick={onConfirm}>
                    {t('buttons.remove')}
                </Button>
                <Button
                    variant="contained"
                    color="inherit"
                    name="btn-cancel"
                    onClick={onCancel}>
                    {t('buttons.cancel')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
